  import { defineComponent, type PropType } from "vue";
  import FractionDsnEntite from '@/extend/controls/fractionDsn/FractionDsnEntite';
  import FractionDsnFraction from '@/extend/controls/fractionDsn/FractionDsnFraction';
  import FractionDsnGenre from '@/extend/controls/fractionDsn/FractionDsnGenre';
  import FractionDsnMail from '@/extend/controls/fractionDsn/FractionDsnMail';
  import FractionDsnNom from '@/extend/controls/fractionDsn/FractionDsnNom';
  import FractionDsnNumero from '@/extend/controls/fractionDsn/FractionDsnNumero';
  import FractionDsnPrenom from '@/extend/controls/fractionDsn/FractionDsnPrenom';
  import FractionDsnType from '@/extend/controls/fractionDsn/FractionDsnType';
  import FractionDsn from '@/extend/classes/FractionDsn';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeFractionDsn } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      FractionDsnEntite,
      FractionDsnFraction,
      FractionDsnGenre,
      FractionDsnMail,
      FractionDsnNom,
      FractionDsnNumero,
      FractionDsnPrenom,
      FractionDsnType,
    },

    props: {
      fractionDsn: {
        type: Object as PropType<FractionDsn>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
        entiteStatus: new FieldStatus(false, false, 0),
        strEntite: '',
        fractionStatus: new FieldStatus(false, false, 0),
        strFraction: '',
        genreStatus: new FieldStatus(false, false, 0),
        strGenre: '',
        mailStatus: new FieldStatus(false, false, 0),
        strMail: '',
        nomStatus: new FieldStatus(false, false, 0),
        strNom: '',
        numeroStatus: new FieldStatus(false, false, 0),
        strNumero: '',
        prenomStatus: new FieldStatus(false, false, 0),
        strPrenom: '',
        typeStatus: new FieldStatus(false, false, 0),
        strType: '',
        refFractionDsn: new FractionDsn,
        cloneFractionDsn: new FractionDsn,
      fractionDsnSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.FRACTION_DSN,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editFractionDsn.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editFractionDsn: {
        get(): FractionDsn {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.fractionDsn != undefined) {
              if (this.fractionDsn.id == 0) {
                Alerts.debug('CrudFractionDsn : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneFractionDsn.id != this.fractionDsn.id && !this.saving) {
                this.handleFractionDsnChange();
              }
            }
          }
          return this.refFractionDsn;
        },
        set(value: FractionDsn) {
          this.refFractionDsn = value;
        }
      },

      canCreate (): boolean {
        return this.refFractionDsn.id > 0;
      },

      canDelete (): boolean {
        return true;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },


      entite: {
        get(): string {
          return this.editFractionDsn.entite;
        },
        set(value: string) {
          this.editFractionDsn.entite = value;
          this.fieldUpdated('ENTITE', value);
        }
      },


      fraction: {
        get(): string {
          return this.strFraction;
        },
        set(value: string) {
          const fraction = parseInt(value);
          if (fraction.toString() == value) {
            this.editFractionDsn.fraction = fraction;
            this.fieldUpdated('FRACTION', value);
          }
          this.strFraction = value;
        }
      },


      genre: {
        get(): number {
          return this.editFractionDsn.genre;
        },
        set(value: number) {
          this.editFractionDsn.genre = value;
          this.fieldUpdated('GENRE', value);
        }
      },


      mail: {
        get(): string {
          return this.editFractionDsn.mail;
        },
        set(value: string) {
          this.editFractionDsn.mail = value;
          this.fieldUpdated('MAIL', value);
        }
      },


      nom: {
        get(): string {
          return this.editFractionDsn.nom;
        },
        set(value: string) {
          this.editFractionDsn.nom = value;
          this.fieldUpdated('NOM', value);
        }
      },


      numero: {
        get(): string {
          return this.editFractionDsn.numero;
        },
        set(value: string) {
          this.editFractionDsn.numero = value;
          this.fieldUpdated('NUMERO', value);
        }
      },


      prenom: {
        get(): string {
          return this.editFractionDsn.prenom;
        },
        set(value: string) {
          this.editFractionDsn.prenom = value;
          this.fieldUpdated('PRENOM', value);
        }
      },


      type: {
        get(): number {
          return this.editFractionDsn.type;
        },
        set(value: number) {
          this.editFractionDsn.type = value;
          this.fieldUpdated('TYPE', value);
        }
      },


      allReadOnly (): boolean {
        const res = (
        (this.isDisplayed('ENTITE') && !this.readOnly('ENTITE')) ||
        (this.isDisplayed('FRACTION') && !this.readOnly('FRACTION')) ||
        (this.isDisplayed('GENRE') && !this.readOnly('GENRE')) ||
        (this.isDisplayed('MAIL') && !this.readOnly('MAIL')) ||
        (this.isDisplayed('NOM') && !this.readOnly('NOM')) ||
        (this.isDisplayed('NUMERO') && !this.readOnly('NUMERO')) ||
        (this.isDisplayed('PRENOM') && !this.readOnly('PRENOM')) ||
        (this.isDisplayed('TYPE') && !this.readOnly('TYPE')));
        return !res;
      },

      fields (): string[] {
        return ['ENTITE', 'FRACTION', 'GENRE', 'MAIL', 'NOM', 'NUMERO', 'PRENOM', 'TYPE'];
      },
    },

    methods: {
      handleFractionDsnChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.fractionDsn);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.fractionDsn);
          }
        } else if (!this.inDialog) {
          if (this.cloneFractionDsn.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.fractionDsn);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.entiteStatus != undefined && this.entiteStatus.updated) ||
          (this.fractionStatus != undefined && this.fractionStatus.updated) ||
          (this.genreStatus != undefined && this.genreStatus.updated) ||
          (this.mailStatus != undefined && this.mailStatus.updated) ||
          (this.nomStatus != undefined && this.nomStatus.updated) ||
          (this.numeroStatus != undefined && this.numeroStatus.updated) ||
          (this.prenomStatus != undefined && this.prenomStatus.updated) ||
          (this.typeStatus != undefined && this.typeStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.fractionDsn);
        }
      },

      setError (): void {
        const error = this.entiteStatus.error ||
        this.fractionStatus.error ||
        this.genreStatus.error ||
        this.mailStatus.error ||
        this.nomStatus.error ||
        this.numeroStatus.error ||
        this.prenomStatus.error ||
        this.typeStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.fractionDsn);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refFractionDsn.id < 0) {
          storeFractionDsn.mFractionDsnDeleted(this.refFractionDsn.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refFractionDsn.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveFractionDsn()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.fractionDsnSaving = false;
          this.createRef(this.refFractionDsn);
          this.$emit('updated', this.refFractionDsn);
          if (this.fractionDsn.id > 0) {
            this.$emit('saved', this.refFractionDsn);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refFractionDsn.failed) {
          this.saveLoading = false;
            this.fractionDsnSaving = false;
            this.refFractionDsn.failed = false;
          }
        }
      },

      saveFractionDsn (): boolean {
        if (!this.refFractionDsn.compareFractionDsn(this.cloneFractionDsn)) {
          if (!this.fractionDsnSaving) {
            this.fractionDsnSaving = true;
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refFractionDsn.id <= 0) {
          storeFractionDsn.mFractionDsnDeleted(this.refFractionDsn.id);
        }
      },

      statusEntite (value: FieldStatus): void {
        this.entiteStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusFraction (value: FieldStatus): void {
        this.fractionStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusGenre (value: FieldStatus): void {
        this.genreStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusMail (value: FieldStatus): void {
        this.mailStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNom (value: FieldStatus): void {
        this.nomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNumero (value: FieldStatus): void {
        this.numeroStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPrenom (value: FieldStatus): void {
        this.prenomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusType (value: FieldStatus): void {
        this.typeStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteFractionDsn(): void {
        this.$emit('deleteFractionDsn',  this.fractionDsn);
      },

    addFractionDsn(): void {
      this.$emit('addFractionDsn',  this.fractionDsn);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneFractionDsn != undefined) {
          this.restoring = true;
          this.refFractionDsn.entite = this.cloneFractionDsn.entite;
          this.refFractionDsn.fraction = this.cloneFractionDsn.fraction;
          this.refFractionDsn.genre = this.cloneFractionDsn.genre;
          this.refFractionDsn.mail = this.cloneFractionDsn.mail;
          this.refFractionDsn.nom = this.cloneFractionDsn.nom;
          this.refFractionDsn.numero = this.cloneFractionDsn.numero;
          this.refFractionDsn.prenom = this.cloneFractionDsn.prenom;
          this.refFractionDsn.type = this.cloneFractionDsn.type;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: FractionDsn): void {
        this.clearRef();
        this.editFractionDsn = value;
        this.cloneFractionDsn = value.cloneFractionDsn();
        this.entiteStatus.clear(value.id);
        this.fractionStatus.clear(value.id);
        this.genreStatus.clear(value.id);
        this.mailStatus.clear(value.id);
        this.nomStatus.clear(value.id);
        this.numeroStatus.clear(value.id);
        this.prenomStatus.clear(value.id);
        this.typeStatus.clear(value.id);
        this.status.clear();
        this.strFraction = this.editFractionDsn.fraction.toString();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ENTITE') && this.$refs.ENTITE) this.$refs.ENTITE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FRACTION') && this.$refs.FRACTION) this.$refs.FRACTION.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('GENRE') && this.$refs.GENRE) this.$refs.GENRE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TYPE') && this.$refs.TYPE) this.$refs.TYPE.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ENTITE') && this.isDisplayed('ENTITE') && this.$refs.ENTITE && this.$refs.ENTITE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'FRACTION') && this.isDisplayed('FRACTION') && this.$refs.FRACTION && this.$refs.FRACTION.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'GENRE') && this.isDisplayed('GENRE') && this.$refs.GENRE && this.$refs.GENRE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'MAIL') && this.isDisplayed('MAIL') && this.$refs.MAIL && this.$refs.MAIL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NOM') && this.isDisplayed('NOM') && this.$refs.NOM && this.$refs.NOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NUMERO') && this.isDisplayed('NUMERO') && this.$refs.NUMERO && this.$refs.NUMERO.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PRENOM') && this.isDisplayed('PRENOM') && this.$refs.PRENOM && this.$refs.PRENOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'TYPE') && this.isDisplayed('TYPE') && this.$refs.TYPE && this.$refs.TYPE.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('ENTITE') && this.$refs.ENTITE) this.$refs.ENTITE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FRACTION') && this.$refs.FRACTION) this.$refs.FRACTION.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('GENRE') && this.$refs.GENRE) this.$refs.GENRE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('TYPE') && this.$refs.TYPE) this.$refs.TYPE.save();
      },

      getValue (field: string): string {
         if (field == 'ENTITE') return this.entite.toString();
        else  if (field == 'FRACTION') return this.fraction.toString();
        else  if (field == 'GENRE') return this.genre.toString();
        else  if (field == 'MAIL') return this.mail.toString();
        else  if (field == 'NOM') return this.nom.toString();
        else  if (field == 'NUMERO') return this.numero.toString();
        else  if (field == 'PRENOM') return this.prenom.toString();
        else  if (field == 'TYPE') return this.type.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
